module.exports = __webpack_public_path__ + "img/Chain1.d01e2e4c.jpg";